import { Message } from 'primeng/primeng';
import { AuthService } from './../../../services/auth.service';
import { FormBuilder } from '@angular/forms';
import { StoreService } from './../../../services/store.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
display = false;
login: string;
closable = false;
modal = true;
draggable = false;
confirmeNewPassword: string;
newPassword: string;
oldPassword: string;
currentUser: any;
msgs: Message[] = [];
displaychargement = false;
  constructor( private store: StoreService,
    private formBuilder: FormBuilder,
    private authService: AuthService) { }

  ngOnInit() {
    console.log('this.authService.currentUser.shouldChangePassword: ', this.authService.currentUser.shouldChangePassword);
    this.display = this.authService.currentUser.shouldChangePassword;
    this.closable = false;
  }
  onClick(){
    this.display = true;
    this.closable = true;
  }
  get regexPassword() {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,100}$/;
  }

  async changerPassword() {
    console.log('in changerPassword !!!');
    console.log('newPassword: ', this.newPassword);
    console.log('confirmeNewPassword: ', this.confirmeNewPassword);
    console.log('oldPassword: ', this.oldPassword);
    console.log('login: ', this.authService.currentUser.login );
    
    if (!(new RegExp(this.regexPassword)).test(this.newPassword)) {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Le mot de passe est faible' });
      return;
    }

    if(this.newPassword === this.oldPassword){
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Le mot de passe est identique à l\'ancien' });
      return;
    }
    if(this.newPassword !== this.confirmeNewPassword){
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Le mot de passe n\'est pas vérifié' });
      return;
    }
    this.displaychargement = true;
    try {
      this.currentUser = await this.authService.changerPassword({oldPassword: this.oldPassword, newPassword: this.newPassword, confirmeNewPassword: this.confirmeNewPassword, login: this.authService.currentUser.login  }).toPromise();
     console.log('this.currentUser: ', this.currentUser);

      // this.store.setValue('user', this.currentUser.agent);
      // this.store.setValue('accessToken', this.currentUser.token);
      // this.store.setValue('login', this.currentUser.agent.login);
      // console.log('this.store.setItem: ', this.store.getItem('user'));
      // console.log('this.store.accessToken: ', this.store.getItem('accessToken'));
      // sessionStorage.setItem("SESSION_RELAD_FIRST", "OK");
      // this.router.navigate(['/root/accueil']);
      window.location.href = '#/login';
      //window.location.reload();
    } catch (error) {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Login ou mot de passe incorrecte !!!' });
    } finally {
      this.displaychargement = false;
    }
  }
}
